import { openBiDirectionalChannelWithResponse } from '../utils';
import { ACTION_REGISTRATION } from '../constants';
var registerActions = (params, subscriptionConfig) => {
  openBiDirectionalChannelWithResponse(params, {
    type: ACTION_REGISTRATION,
    payload: subscriptionConfig
  });
};
export default registerActions;